export default "__VITE_ASSET__CITUmnye__"